<template>
  <div
    class="contentLayoutBox"
    :style="{width: width}"
  >
    <div class="title-row topBox">
      <h3 v-if="breadTitle.length === 0">
        {{ contentTitle }}
      </h3>
      <bread-crumb
        v-else
        :breadcrumb="breadTitle"
        separator=">"
      />
      <div class="title-box">
        <slot name="title" />
      </div>
      <!-- v-show="!isNoData" -->
      <div class="btn-box-top fr clearfix">
        <slot name="btnTop" />
      </div>
    </div>
    <div class="content">
      <slot name="content" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isNoData: {
      type: Boolean
    },
    isLoading: {
      type: Boolean
    },
    nothingText: {
      type: String
    },
    width: {
      type: String,
      default: '100%'
    },
    title: {
      type: String
    },
    slotTitle: {
      type: Array
    }
  },
  data() {
    // console.log((this.slotTitle || []).filter(item => {
    //   return !item.meta.root
    // }))
    return {
      breadTitle: (this.slotTitle || []).filter(item => {
        return !item.meta.root
      })
    }
  },
  computed: {
    contentTitle() {
      return this.slotTitle ? '' : (this.title ? this.title : ((this.$route.meta && this.$route.meta.title) ? this.$route.meta.title : ''))
    }
  }
}
</script>
<style lang="scss" scoped type="text/scss">
  .contentLayoutBox{
    border-radius: 8px;
    border:1px solid #ccc;
    width:100%;
    .el-breadcrumb{
      display: inline-block !important;
    }
    // overflow: hidden;
    .topBox{
      padding: 0px 30px;
      border-bottom:1px solid #ccc;
      height: 60px;
      line-height: 60px;
      .el-breadcrumb{
        height: 60px !important;
        line-height: 60px !important;
      }
      h3{
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
      }
      .btn-box-top, .title-box{
        display: inline-block;
      }
    }
    .content{
      border-radius: 8px;
      position: relative;
      padding: 30px;
      background: #ffffff;
      // min-height: 500px;
    }
  }
</style>
